import { GraphQLClient } from "graphql-request";
import { useAuth } from "react-oauth2-pkce";

const endpoint = `${
  process?.env?.REACT_APP_GATEWAY_URL ||
  window?.environment?.REACT_APP_GATEWAY_URL
}/graphql`;

export function useStoresGateway() {
  const { authService } = useAuth();
  const jwt = authService.getAuthTokens().access_token;
  const graphQLClient = new GraphQLClient(endpoint, {
    headers: {
      authorization: `Bearer ${jwt}`,
    },
  });

  return {
    graphQLClient,
    request: graphQLClient.request.bind(graphQLClient),
  };
}
